import request from '@/utils/request'

let HealthApi = {

  /*健康档案列表*/
  list(data) {
    return request._post('/shop/plus.health.Index/index', data);
},
/*添加健康档案*/
add(data) {
    return request._post('/shop/plus.health.Index/add', data);
},
/*修改健康档案*/
edit(data) {
    return request._post('/shop/plus.health.Index/edit', data);
},
/*删除健康档案*/
del(data) {
    return request._post('/shop/plus.health.Index/del', data);
},
/*健康档案详情*/
detail(data) {
  return request._post('/shop/plus.health.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.health.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.health.Setting/getSetting', data, errorback);
    },
}
export default HealthApi;



// WEBPACK FOOTER //
// ./src/api/health.js